import React from 'react';
import { Icon } from '@rsuite/icons';
import { NavItemProps } from './components/Frame/Frame';
import { RoleEnum } from './models/user.model';
import { VscTable } from 'react-icons/vsc';

import { MdDashboard, MdPerson, MdLocationCity, MdMap, MdEmojiEvents, MdDirectionsRun, MdEventAvailable, MdLocationOn, 
  MdRoute, MdBugReport, MdDirectionsBike, MdReportGmailerrorred, MdKey, MdGroups2, MdMenuBook, MdLocalOffer, 
  MdLibraryBooks, MdLanguage, MdPlayCircle, MdRedeem,MdCurrencyExchange,
  MdShoppingBasket,
  MdWatch,
  MdOfflineShare,
  MdStyle,
  MdCollections,
  MdDescription,
  MdDiamond,
  MdAccountBalanceWallet,
  MdStorefront,
  MdReceiptLong,
  MdPercent,
  MdBolt,
  MdFactCheck} from 'react-icons/md';

export const appNavs : NavItemProps[] = [
  {
    eventKey: 'dashboard',
    icon: <Icon as={MdDashboard} />,
    title: 'Dashboard',
    to: '/dashboard'
  },
  {
    eventKey: 'users',
    icon: <Icon as={MdPerson} />,
    title: 'Users',
    to: '/users'
  },
  {
    eventKey: 'activity-grp',
    icon: <Icon as={MdDirectionsBike} />,
    title: 'Activities',
    to: '/activity-grp',
    children:[
      {
        eventKey: 'activities',
        icon: <Icon as={MdDirectionsBike} />,
        title: 'Activities',
        to: '/activities',
      },      
      {
        eventKey: 'activity-reports',
        icon: <Icon as={MdReportGmailerrorred} />,
        title: 'Activity Reports',
        to: '/activities/reports',
      },      
    ]

  },
  {
    eventKey: 'achievements',
    icon: <Icon as={MdEmojiEvents} />,
    title: 'Achievements',
    to: '/achievements',
  },
  {
    eventKey: 'run-event-grp',
    icon: <Icon as={MdEventAvailable} />,
    title: 'Run Events',
    to: '/run-event-grp',
    children:[
      {
        eventKey: 'run-events',
        title: 'Run Events',
        to: '/run-events',
        icon: <Icon as={MdDirectionsRun} />,
      },          
      {
        eventKey: 'run-event-keys',
        title: 'Run Event Keys',
        to: '/run-event-keys',
        icon: <Icon as={MdKey} />,
      },          
    ]
  },
  {
    eventKey: 'discovery-points',
    icon: <Icon as={MdLocationOn} />,
    title: 'Discovery Points',
    to: '/discovery-points',
  },
  {
    eventKey: 'routes',
    icon: <Icon as={MdRoute} />,
    title: 'Routes',
    to: '/routes',
  },
  {
    eventKey: 'running-club-grp',
    icon: <Icon as={MdGroups2} />,
    title: 'Running Clubs',
    to: '/running-club-grp',
    children:[
      {
        eventKey: 'running-clubs',
        icon: <Icon as={MdGroups2} />,
        title: 'Running Clubs',
        to: '/running-clubs',
      },
      {
        eventKey: 'running-club-events',
        icon: <Icon as={MdEventAvailable} />,
        title: 'Event',
        to: '/running-clubs/events',
      },
      {
        eventKey: 'running-club-tags',
        icon: <Icon as={MdLocalOffer} />,
        title: 'Tags',
        to: '/running-clubs/tags',
      },
    ]
  },
  {
    eventKey: 'story-grp',
    icon: <Icon as={MdMenuBook} />,
    title: 'Stories',
    to: '/story-grp',
    children:[
      {
        eventKey: 'stories',
        icon: <Icon as={MdMenuBook} />,
        title: 'Stories',
        to: '/stories',
      },     
      {
        eventKey: 'encyclopedia-items',
        icon: <Icon as={MdLibraryBooks} />,
        title: 'Encyclopedia Items',
        to: '/encyclopedia-items',
      },     
    ]

  },
  {
    eventKey: 'scraped-events',
    icon: <Icon as={MdLanguage} />,
    title: 'Scraped Events',
    to: '/scraped-events',
  },      
  {
    eventKey: 'subscription-grp',
    icon: <Icon as={MdCurrencyExchange} />,
    title: 'Subscriptions',
    to: '/subscription-grp',
    children:[
      {
        eventKey: 'plans',
        icon: <Icon as={MdCurrencyExchange} />,
        title: 'Plans',
        to: '/subscription/plans',
      },     
      {
        eventKey: 'redeem-codes',
        icon: <Icon as={MdRedeem} />,
        title: 'Redeem Codes',
        to: '/subscription/codes',
      },     
    ]

  },
  {
    eventKey: 'points',
    icon: <Icon as={MdDiamond} />,
    title: 'Points',
    to: '/points-grp',
    children: [
      {
        eventKey: 'point-transactions',
        icon: <Icon as={MdReceiptLong} />,
        title: 'Point Transactions',
        to: '/point-transactions',
      },
      {
        eventKey: 'point-types',
        icon: <Icon as={MdStyle} />,
        title: 'Point Types',
        to: '/point-types',
      },
      {
        eventKey: 'point-accounts',
        icon: <Icon as={MdAccountBalanceWallet} />,
        title: 'Point Accounts',
        to: '/point-accounts',
      },
    ],
  },
  {
    eventKey: 'energy-hub-grp',
    icon: <Icon as={MdBolt} />,
    title: 'Energy Hubs',
    to: '/energy-hub-grp',
    children: [
      {
        eventKey: 'energy-hubs',
        icon: <Icon as={MdStorefront} />,
        title: 'Hubs',
        to: '/energy-hubs',
      },
      {
        eventKey: 'energy-hub-receipts',
        icon: <Icon as={MdFactCheck} />,
        title: 'Receipt Queue',
        to: '/energy-hub-receipts',
      },
      {
        eventKey: 'energy-hub-runs',
        icon: <Icon as={MdDirectionsRun} />,
        title: 'Hub Run Requests',
        to: '/energy-hub-runs',
      },
    ],
  },
  {
    eventKey: 'marketplace',
    icon: <Icon as={MdStorefront} />,
    title: 'Marketplace',
    to: '/marketplace-grp',
    children: [
      {
        eventKey: 'marketplace-purchases',
        icon: <Icon as={MdReceiptLong} />,
        title: 'Purchases',
        to: '/marketplace/purchases',
      },
      {
        eventKey: 'marketplace-commission-policies',
        icon: <Icon as={MdPercent} />,
        title: 'Commission Policies',
        to: '/marketplace/commission-policies',
      },
    ]
  },
  {
    eventKey: 'brand',
    icon: <Icon as={MdShoppingBasket} />,
    title: 'Brands',
    to: '/brands-grp',
    children:[
      {
        eventKey: 'sport-brand',
        icon: <Icon as={MdShoppingBasket} />,
        title: 'Sport Brands',
        to: '/sport-brands',
      },     
      {
        eventKey: 'brand-gears',
        icon: <Icon as={MdWatch} />,
        title: 'Brand Gears',
        to: '/brand-gears',
      },     
    ]

  },
  {
    eventKey: 'advance-share',
    icon: <Icon as={MdOfflineShare} />,
    title: 'Advance Shares',
    to: '/advance-shares-grp',
    children:[
      {
        eventKey: 'advance-share-styles',
        icon: <Icon as={MdStyle} />,
        title: 'Styles',
        to: '/advance-shares/styles',
      },
      {
        eventKey: 'advance-share-packs',
        icon: <Icon as={MdCollections} />,
        title: 'Packs',
        to: '/advance-shares/packs',
      },
      {
        eventKey: 'advance-share-templates',
        icon: <Icon as={MdDescription} />,
        title: 'Templates',
        to: '/advance-shares/templates',
      },
    ]

  },
  {
    eventKey: 'master-data',
    icon: <Icon as={VscTable} />,
    title: 'Master Data',
    to: '/master-data',
    access: [RoleEnum.Admin],
    children: [
      {
        eventKey: 'continents',
        title: 'Continents',
        to: '/continents',
        icon: <Icon as={MdLocationOn} />,
      },
      {
        eventKey: 'countries',
        title: 'Countries',
        to: '/countries',
        icon: <Icon as={MdMap} />,
      },
      {
        eventKey: 'cities',
        title: 'Cities',
        to: '/cities',
        icon: <Icon as={MdLocationCity} />,
      },
      {
        eventKey: 'activity-bug-solver',
        title: 'Activity Bug Solver',
        to: '/activity-bug-solver',
        icon: <Icon as={MdBugReport} />,
      },
      {
        eventKey: 'global-actions',
        title: 'Global Actions',
        to: '/global-actions',
        icon: <Icon as={MdPlayCircle} />,
      },
    ]
  },
  
];
